module.exports = __webpack_public_path__ + "static/img/game8.413fb1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game8.jpg
// module id = YziD
// module chunks = 1